<template>
  <h1>+
    <span class="counter"
          v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions }">{{displayValue | formatNumber}}</span>{{suffix}}
  </h1>
</template>
<script>
export default {
  name: 'counter-up',
  props: ['value', 'suffix', 'step'],
  data() {
    return {
      displayValue: 0,
      numberLimit: Number(this.value),
      stepValue: Number(this.step),
      intersectionOptions: {
        root: null,
        rootMargin: '0px 0px 0px 0px',
        thresholds: [0]
      }
    };
  },
  methods: {
    onWaypoint({ going, direction }) {
      if (going === this.$waypointMap.GOING_IN) {
        setTimeout(() => {
          if (this.displayValue !== this.numberLimit) {
            this.updateDisplayValue();
          }
        }, 20);
      }
    },
    updateDisplayValue() {
      setTimeout(() => {
        if (this.displayValue < this.numberLimit) {
          this.displayValue += this.stepValue;
          if (this.displayValue > this.numberLimit) {
            this.displayValue = this.numberLimit;
          }
          this.updateDisplayValue();
        }
      }, 5);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/commons/CounterUp.vue